/**
 * 议程分类标签 i18n helper
 */

import type { TranslationKeys } from '@/locales';
import type { AgendaCategoryTag } from '@/services/api/agenda';

export const AGENDA_CATEGORY_TAGS: AgendaCategoryTag[] = [
  'FFAI_EAI_EV',
  'EAI_ROBOTICS',
  'MIXED',
  'OTHER',
];

export function getCategoryTagLabel(
  tag: AgendaCategoryTag | null | undefined,
  t: TranslationKeys,
): string {
  if (!tag) return '';
  const map: Record<AgendaCategoryTag, string> = {
    FFAI_EAI_EV: t.meetingAttendance.agenda.categoryTag.ffaiEaiEv,
    EAI_ROBOTICS: t.meetingAttendance.agenda.categoryTag.eaiRobotics,
    MIXED: t.meetingAttendance.agenda.categoryTag.mixed,
    OTHER: t.meetingAttendance.agenda.categoryTag.other,
  };
  return map[tag];
}

/** 议程项分类徽章配色（轻量 inline tag） */
export const CATEGORY_TAG_CLASS: Record<AgendaCategoryTag, string> = {
  FFAI_EAI_EV: 'bg-purple-50 text-purple-700 border border-purple-200',
  EAI_ROBOTICS: 'bg-blue-50 text-blue-700 border border-blue-200',
  MIXED: 'bg-amber-50 text-amber-700 border border-amber-200',
  OTHER: 'bg-gray-100 text-gray-700 border border-gray-200',
};
